export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "covered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Couvert"])},
        "not_covered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non couvert"])}
      },
      "en": {
        "covered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Covered"])},
        "not_covered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not covered"])}
      }
    }
  })
}
